import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RequestResultSettingsService } from "../../../shared/services/request-result-settings.service";
import { LookupService } from "../../../shared/services/lookup.service";
import { RequestResultSettingDto } from "../../../shared/models/request-result-settings/request-result-setting.dto";
import { ContragentType } from "../../../shared/enums";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../shared/models/core/KeyValueObject";
import { ComponentPageBase } from "../../../shared/components/component-page-base/component-page-base";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "../../../app.service";
import { NotificationService } from "../../../core/services/notification.service";
import { EntityViewModel } from "../../../shared/models/core/EntityViewModel";

@Component({
    selector: 'request-result-setting-modal',
    templateUrl: './request-result-setting-modal.html',
    styleUrls: ['./request-result-setting-modal.scss',
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss'],
})
export class RequestResultSettingModal extends ComponentPageBase<RequestResultSettingDto> implements OnInit {

    @Input() setting: RequestResultSettingDto = null;

    @Output() cancelEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() continueEvent: EventEmitter<any> = new EventEmitter<any>();

    requestTypes: KeyValueObject[] = [];
    contragents: KeyValueObject[] = [];
    requestStatuses: KeyValueObject[] = [];
    requestResults: KeyValueObject[] = [];

    dataLoading: boolean = false;

    constructor(
        protected lookupService: LookupService,
        protected requestResultSettingsService: RequestResultSettingsService,
        protected route: ActivatedRoute,
        protected router: Router,
        protected appService: AppService,
        protected notificationService: NotificationService,
    ) {
        super(route, router, appService, notificationService, requestResultSettingsService);
        this.listPageRoutePath = 'categories/request-result-settings';
        this.appService.pageTitle = 'Результат заявки';
        this.entityName = "Результат заявки";
    }

    ngOnInit(): void {
        this.entityViewModel = new EntityViewModel<RequestResultSettingDto>();
        if (this.setting != null) {
            this.entityViewModel.entity = this.setting;
        }
        else {
            this.entityViewModel.entity = new RequestResultSettingDto();
            this.isNew = true;
        }

        this.dataLoading = true;
        var clientsState: DataSourceRequestState = {
            filter: {
                logic: "and",
                filters: [{ field: 'contragentTypeId', operator: 'eq', value: <number>ContragentType.bankEquer }]
            }
        };

        const requestTypes$ = this.lookupService.getData('request-types', null);
        const contragents$ = this.lookupService.getData('contragents', clientsState);
        const requestStatuses$ = this.lookupService.getData('request-statuses', null);
        const requestResults$ = this.lookupService.getData('request-results', null);

        forkJoin([requestTypes$, contragents$, requestStatuses$, requestResults$])
            .subscribe(([requestTypes, contragents, requestStatuses, requestResults]) => {
                this.requestTypes = requestTypes;
                this.contragents = contragents;
                this.requestStatuses = requestStatuses;
                this.requestResults = requestResults;
                this.dataLoading = false;
            });
    }

    cancel() {
        this.cancelEvent.emit();
    }

    afterSaveChanges() {
        this.continueEvent.emit();
    }
}
